import React from "react";
import PropTypes from "prop-types";
import HistoryIcon from "@material-ui/icons/History";
import clsx from "clsx";
import { getFormattedDate } from "../../../../../Utils/Helpers/dateUtils";
import useStyles from "./ProfessionalContacts.styles";

const DeletedBankAccountsHistory = ({ deletedBankAccounts }) => {
  const classes = useStyles();
  if (!deletedBankAccounts || deletedBankAccounts.length === 0) return null;

  return (
    <>
      <div className={classes.sectionHeading}>
        <HistoryIcon fontSize="inherit" /> Deleted bank accounts (
        {deletedBankAccounts.length})
      </div>
      {deletedBankAccounts.map((bankAccount, index) => (
        <div
          key={`${bankAccount.accountNumber}-${index}`}
          className={clsx(classes.rowItem, classes.rowItemDeleted)}
        >
          <div className={classes.rowGrow}>
            <span className={classes.strikethrough}>
              {bankAccount.beneficiaryName || "(unnamed)"}
            </span>
            <div className={classes.subtle}>
              {bankAccount.bankName} · {bankAccount.sortCode} ·{" "}
              {bankAccount.accountNumber}
            </div>
          </div>
          <span className={classes.rowMeta}>
            Removed {getFormattedDate(bankAccount.deletedUtc, "DD/MM/YYYY, HH:mm") || "-"}
            {getFormattedDate(bankAccount.deletedUtc, "DD/MM/YYYY, HH:mm") ||
              "—"}
            {bankAccount.deletedBy ? (
              <>
                <br />
                by {bankAccount.deletedBy}
              </>
            ) : null}
          </span>
        </div>
      ))}
      <div className={classes.hint}>Retained for audit. Deleted bank accounts are no longer selectable anywhere.</div>
    </>
  );
};

DeletedBankAccountsHistory.propTypes = {
  deletedBankAccounts: PropTypes.array,
};

export default DeletedBankAccountsHistory;
